import {
    AutomotiveSubscriptionStatus,
    VehicleLifecycleState,
} from '@sxm-de/dev-kits/web-sdk/types';

export function getAutomotiveSubscriptionStatusFromLifecycleState(
    lifecycleState: VehicleLifecycleState | null,
): AutomotiveSubscriptionStatus {
    if (!lifecycleState) {
        throw new Error('VEHICLE_NOT_FOUND');
    }
    if (lifecycleState.trialEligible) {
        return 'TRIAL_ELIGIBLE';
    } else if (lifecycleState.trial?.phase) {
        if (lifecycleState.trial.phase.anonymous) {
            return 'TRIAL_NOT_CLAIMED';
        } else if (lifecycleState.trial.phase.claimed) {
            return 'TRIAL_CLAIMED';
        } else if (lifecycleState.trial.phase.followOn) {
            return 'TRIAL_WITH_FOLLOW_ON';
        }
    } else if (lifecycleState.selfPay) {
        return 'SELF_PAY';
    } else if (lifecycleState.inactive) {
        return 'INACTIVE';
    }
    throw new Error('VEHICLE_NOT_FOUND');
}
